// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-select {
  display: flex;
  flex-direction: row;
  gap: var(--dialog-element-gap);

  > button {
    flex-shrink: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/session-select/SessionSelect.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B;IACE,cAAc;EAChB;AACF","sourcesContent":[".session-select {\n  display: flex;\n  flex-direction: row;\n  gap: var(--dialog-element-gap);\n\n  > button {\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
